// Shared LLM provider catalogue and BYOK key storage. Used by the main menu
// (config screens) and by the puzzle-complete modal (model switcher), so the
// two never drift.

// AlphaZero runs on-device (ONNX in a web worker, public/models/): the
// phutball-jax self-play network (it 100), 21x15 only.
export const LLM_PROVIDERS = {
  AlphaZero: ['AZ-playouts-50', 'AZ-playouts-100', 'AZ-playouts-200', 'AZ-playouts-400'],
  Google: ['gemini-3.5-flash', 'gemini-3.1-pro', 'gemini-3.1-flash-lite-preview', 'gemini-2.5-flash'],
  Anthropic: ['claude-fable-5-1', 'claude-opus-5', 'claude-sonnet-5', 'claude-opus-4-8', 'claude-opus-4-7', 'claude-opus-4-6', 'claude-sonnet-4-6', 'claude-haiku-4-5'],
  OpenAI: ['gpt-5', 'gpt-5.5', 'gpt-5.4-mini', 'gpt-4o-mini'],
  XAI: ['grok-4.3', 'grok-4.1-fast'],
  OpenRouter: [
    'moonshotai/kimi-k2.6',
    'xiaomi/mimo-v2-pro',
    'deepseek/deepseek-v3.2',
    'qwen/qwen3.6-plus',
    'meta-llama/llama-4-maverick',
    'meta-llama/llama-4-scout',
    'mistralai/mistral-large-2512',
  ],
};

// SessionStorage key for API keys (cleared when browser tab closes)
export const API_KEYS_STORAGE_KEY = 'phutball_api_keys';

// Load API keys from sessionStorage (NOT localStorage - more secure)
export const loadApiKeys = () => {
  try {
    const stored = sessionStorage.getItem(API_KEYS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

export const saveApiKeys = (keys) => {
  try {
    sessionStorage.setItem(API_KEYS_STORAGE_KEY, JSON.stringify(keys));
  } catch {
    console.warn('Failed to save API keys to sessionStorage');
  }
};
